import { render, staticRenderFns } from "./TTModal.vue?vue&type=template&id=503ff13a&scoped=true&"
import script from "./TTModal.vue?vue&type=script&lang=js&"
export * from "./TTModal.vue?vue&type=script&lang=js&"
import style0 from "./TTModal.vue?vue&type=style&index=0&id=503ff13a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503ff13a",
  null
  
)

export default component.exports